import React from 'react';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import ModifyAvailableVacation from './ModifyAvailableVacation';
import AvailableVacationRow from './AvailableVacationRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import NewAvailableVacation from './NewAvailableVacation';

export const availableVacationActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Elérhető szabadság módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => row.privateId,
        actionComponent: (props, close) => <ModifyAvailableVacation {...props} close={close} />
    }, 
    {
        dataDialog: "new-dialog",
        title: "Új",
        dialogTitle: "Elérhető szabadság létrehozása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => !row.privateId,
        actionComponent: (props, close) => <NewAvailableVacation {...props} close={close} />
    }, 
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Elérhető szabadság törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/availablevacation'} comp={<AvailableVacationRow {...props} />} />
    }
]